import {ColumnMain} from "#/models/column-main";
import {Column} from "#/models/column";
import {Trans} from "@lingui/macro";
import React from "react";

const ItemModel = () : ColumnMain => {

    const columns : Array<Column> = new Array();
    columns.push({key:'itemNo', dataIndex: 'itemNo', width: 150, filter:true, sorter:true,title:<Trans>ItemNo</Trans>});
    columns.push({key:'fifoNumber', dataIndex: 'fifoNumber', width: 120, filter:true, sorter:true,title:<Trans>FIFO</Trans>});
    columns.push({key:'quality', width: 120, filter:true, sorter:true,title:<Trans>Quality</Trans>});
    columns.push({key:'normWeight', width: 120, filter:true, sorter:true,title:<Trans>Norm Weight</Trans>});
    columns.push({key:'sizeX', width: 100, filter:true, sorter:true,title:<Trans>Size X</Trans>});
    columns.push({key:'sizeY', width: 100, filter:true, sorter:true,title:<Trans>Size Y</Trans>});
    columns.push({key:'suppliers', width: 200, sorter:true, render: (text: any, record: any) => {
        return record.suppliers && record.suppliers.length > 0 ? record.suppliers.map((s: any) => s.name).join(', ') : '-';
    }, title:<Trans>Suppliers</Trans>});
    columns.push({key:'updatedDate', width: 150, dateFilter:true, sorter:true,title:<Trans>Updated Date</Trans>});
    columns.push({key:'updatedBy', width: 150, sorter:true,title:<Trans>Updated By</Trans>});
    columns.push({key:'createdDate', width: 150, dateFilter:true, sorter:true,title:<Trans>Created Date</Trans>,direction:"desc"});
    columns.push({key:'createdBy', width: 150, sorter:true,title:<Trans>Created By</Trans>});

    return{
        columns:columns,
        url:"/resource/items"
    };

}
export default ItemModel();
